module.exports = __webpack_public_path__ + "static/media/the-sea.f86b20c4.mp3";